import React from 'react';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import SettingsIcon from '@mui/icons-material/Settings';
import { styled } from '@mui/material/styles';
import { keyframes } from '@emotion/react';

const spin = keyframes`
  from { transform: rotate(0deg); }
  to   { transform: rotate(360deg); }
`;

const CircularBackground = styled('div')({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '50%',
  backgroundColor: 'rgba(255,255,255,0.15)',
  width: 32,
  height: 32,
  transition: 'background-color 0.2s',
  '&:hover': {
    backgroundColor: 'rgba(255,255,255,0.25)',
  },
});

const RotatingSettingsIcon = styled(SettingsIcon)(({ duration }) => ({
  animation: `${spin} ${duration}s linear infinite`,
  width: 20,
  height: 20,
  color: '#FFFFFF',
}));

function ButtonConfig({ handleClick, openTooltip, spinDuration = 8 }) {
  return (
    <Tooltip title="Configuración de estilos">
      <IconButton
        onClick={handleClick}
        size="small"
        aria-controls={openTooltip ? 'config-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={openTooltip ? 'true' : undefined}
      >
        <CircularBackground>
          <RotatingSettingsIcon duration={spinDuration} />
        </CircularBackground>
      </IconButton>
    </Tooltip>
  );
}

export default ButtonConfig;
